import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'concourse-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit, OnChanges {

  @Input("expanded") expanded: boolean = false;
  @Input('id') id: string = null;
  @Input('roomnumber') roomnumber: string = null;
  @Input('name') name: string = null;
  @Input('url') url: string = null;
  @Input('created_date') date: any;
  @Output('onImageClick') imageClick: EventEmitter<any> = new EventEmitter(null);

  constructor() { }

  ngOnChanges(): void {
  }

  ngOnInit(): void {
  }

  onImageClick() {
    this.imageClick.emit(this.id);
  }


}
